export const SET_MAP_AND_VIEW = 'map/SET_MAP_AND_VIEW'
